
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { FinancialInputSection } from "./customer-priorities/components/FinancialInputSection";
import { ChartGrid } from "./customer-priorities/components/ChartGrid";
import { useFinancialData } from "./customer-priorities/hooks/useFinancialData";
import { Account } from "./customer-priorities/types";
import ErrorDialog from "@/components/finance/leaderboard/ErrorDialog";

const CustomerPrioritiesTab = ({
  selectedAccount
}: {
  selectedAccount: Account | null;
}) => {
  const {
    isLoadingFinancials,
    financialData,
    companyNameInput,
    setCompanyNameInput,
    rawFinancialResponse,
    fetchFinancialData,
    isOwner,
    canEdit,
    isSupervisor,
    ownershipLoaded,
    showErrorDialog,
    setShowErrorDialog,
    errorMessage
  } = useFinancialData(selectedAccount);

  return (
    <>
      <Card className="bg-secondary/50 backdrop-blur-lg border-2 border-primary rounded-lg shadow-lg shadow-purple-500/10 my-[12px]">
        <CardContent className="mt-4">
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-xl font-semibold text-white">Financial Summary</h2>
            <p className="text-[12px] text-white">Note: AI hallucination may occur. Validation of generated information is essential.</p>
          </div>
          
          {selectedAccount && (
            <p className="text-[11px] text-primary-light mb-3">
              Selected Account ID: {selectedAccount.company_id} ({selectedAccount.company_name})
            </p>
          )}

          {isSupervisor && (
            <div className="mb-2 p-1 bg-primary/20 text-primary border-primary/30 rounded-lg">
              <div className="flex items-center justify-between">
                <p className="text-xs text-secondary-800">
                  You are viewing this account as a supervisor. Only the account owner can modify financial data.
                </p>
              </div>
            </div>
          )}

          <div className="bg-secondary/50 backdrop-blur-lg border border-white rounded-lg shadow-lg shadow-purple-500/10 w-full p-4">
            <FinancialInputSection
              companyNameInput={companyNameInput}
              setCompanyNameInput={setCompanyNameInput}
              isLoadingFinancials={isLoadingFinancials}
              fetchFinancialData={fetchFinancialData}
              rawFinancialResponse={rawFinancialResponse}
              canEdit={canEdit}
            />

            <ChartGrid
              isLoadingFinancials={isLoadingFinancials}
              financialData={financialData}
            />
          </div>
        </CardContent>
      </Card>

      <ErrorDialog
        isOpen={showErrorDialog}
        onOpenChange={setShowErrorDialog}
        errorMessage={errorMessage}
        title="Invalid Ticker Symbol"
      />
    </>
  );
};

export default CustomerPrioritiesTab;
